import { get } from '@/lib/api/client';
import {
	type DashboardContentStatsResponse,
	DashboardContentStatsResponseSchema,
	type DashboardContentPerformanceResponse,
	DashboardContentPerformanceResponseSchema,
	type DashboardOperationalStatsResponse,
	DashboardOperationalStatsResponseSchema,
} from '@/lib/api/types';

export class DashboardService {
	async getContentStats(): Promise<DashboardContentStatsResponse> {
		const res = await get('utils/private/dashboard/content-stats');
		return DashboardContentStatsResponseSchema.parse(res);
	}

	async getOperationalStats(): Promise<DashboardOperationalStatsResponse> {
		const res = await get('utils/private/dashboard/operational-stats');
		return DashboardOperationalStatsResponseSchema.parse(res);
	}

	async getContentPerformance(): Promise<DashboardContentPerformanceResponse> {
		const res = await get('utils/private/dashboard/content-performance');
		return DashboardContentPerformanceResponseSchema.parse(res);
	}
}

export const dashboardService = new DashboardService();

export default dashboardService;